export default __webpack_public_path__ + "static/media/hashSVG.d1508146.svg";